enum ReportsDeliveryScheduleType {
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
}

export default ReportsDeliveryScheduleType;
